import { Modal } from '@pmi/dsm-react';
import { Spinner } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { User } from '../../../../../../shared/models/UserModels';
import { useGetDiagnosticsByProductQuery } from './apiSlice';
import { accountSelector } from '../../../../../../shared/store/shared/accountSlice';
import styles from './diagnosticsModal.module.scss';
import EnrollmentCard from '../../../../../../Hub/TrainingHub/EnrollmentCard';
import ProgressCard from '../../../../../../Hub/TrainingHub/ProgressCard';
import { Product } from '../../../../../../Hub/TrainingHub/models';

interface DiagnosticsModalProps {
  user: User;
  diagnosableProduct?: any;
  onCancel?: () => void;
}

export default function DiagnosticsModal({
  user,
  diagnosableProduct = undefined,
  onCancel = () => {},
}: DiagnosticsModalProps) {
  const { currentAccountId } = useSelector(accountSelector);
  const {
    data: product,
    isLoading,
    isFetching,
  } = useGetDiagnosticsByProductQuery(
    {
      accountId: currentAccountId,
      personId: user.personId,
      userId: user.id,
      sku: diagnosableProduct?.sku,
    },
    { skip: !diagnosableProduct || !user },
  );

  return (
    <Modal
      show={diagnosableProduct}
      onClose={onCancel}
      backdrop="static"
      title="Diagnostics"
      variant="dialog"
      buttons={[
        {
          titleText: 'Close',
          variant: 'outline-secondary',
          onClick: onCancel,
        },
      ]}
      customClassName={styles.diagnosticsModalBody}
    >
      {(isLoading || isFetching) && (
        <div className="d-block p-4 w-100">
          <Spinner size="sm" className="d-block p-4 m-auto" />
        </div>
      )}
      {product && !isLoading && !isFetching && (
        <>
          <code className="break-all-words w-100">
            <pre className="break-all-words break-white-space color-text mb-3">
              {JSON.stringify(product, null, 2)}
            </pre>
          </code>
          <div className={styles.productCardContainer}>
            {(product as Product).addToMyProducts ? (
              <ProgressCard
                product={product}
                onSuccess={() => {}}
                accountId={currentAccountId}
              />
            ) : (
              <EnrollmentCard
                product={product}
                onSuccess={() => {}}
                accountId={currentAccountId}
                isFiltered={false}
              />
            )}
          </div>
        </>
      )}
    </Modal>
  );
}
